<div class="dashboard-home">
  <header class="dashboard-home__header">
    <div>
      <h1 class="page-title">Dashboard</h1>
      <p class="page-subtitle">A quick read on critical admin operations and recent movement.</p>
    </div>

    <div class="dashboard-home__range" role="tablist" aria-label="Dashboard date range">
      @for (option of periodOptions; track option.value) {
      <button
        type="button"
        role="tab"
        [attr.aria-selected]="dashboardState.selectedPeriod() === option.value"
        [class.is-active]="dashboardState.selectedPeriod() === option.value"
        [disabled]="dashboardState.loading()"
        (click)="loadPeriod(option.value)">
        {{ option.label }}
      </button>
      }
    </div>
  </header>

  @if (dashboardState.error()) {
  <section class="dashboard-home__notice" role="alert">
    <ng-glyph name="error" size="20"></ng-glyph>
    <span>{{ dashboardState.error() }}</span>
  </section>
  }
  <app-dashboard-overview-cards
    [cards]="dashboardState.cards()"
    [loading]="dashboardState.loading()"
    [selectedPeriodLabel]="getSelectedPeriodLabel()"></app-dashboard-overview-cards>

  <app-dashboard-fulfillment-funnel
    [loading]="dashboardState.loading()"
    [selectedPeriodLabel]="getSelectedPeriodLabel()"
    [stages]="dashboardState.fulfillmentFunnelStages()"></app-dashboard-fulfillment-funnel>
</div>
